import { render, staticRenderFns } from "./BasicToolbar.vue?vue&type=template&id=4a2cf66b&"
import script from "./BasicToolbar.vue?vue&type=script&lang=js&"
export * from "./BasicToolbar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAppBar } from 'vuetify/lib/components/VAppBar';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VAppBar,VIcon})
